module.exports = __webpack_public_path__ + "img/product_71.08eb653.webp";